export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM_CART = 'REMOVE_ITEM_CART';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const REMOVE_ALL_ITEMS = 'REMOVE_ALL_ITEMS';
export const HANDLE_TOGO_FORM = 'HANDLE_TOGO_FORM';
export const HANDLE_HOW_TO_ORDER = 'HANDLE_HOW_TO_ORDER';
export const HANDLE_OPEN_CART_ORDER = 'HANDLE_OPEN_CART_ORDER';
export const HANDLE_ALL_CART_ASIDE= 'HANDLE_ALL_CART_ASIDE';